import React, { useMemo, useEffect, useState, memo } from 'react'
import { useSelector } from 'react-redux'

import styled from 'styled-components'

import { useToasts } from 'react-toast-notifications'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import TableRolesDisplay from '../../components/TableRolesDisplay'
import moment from 'moment'
import Loader from '../../../../../components/Loader'
import Flex from '../../../../../components/layouts/Flex'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

import CSVDownloader from '../../../../../lib/CSVDownloader'

const RecruitersCandidateCount = () => {
  const { addToast } = useToasts()

  const filters = useSelector((state) => state.dashboard.filters)

  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [rowCount, setRowCount] = useState(0)

  const [loading, setLoading] = useState(false)
  const [columns, setColumns] = useState([])
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchData()
  }, [filters, currentPage, pageSize])

  const fetchData = async () => {
    try {
      setLoading(true)

      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id,
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const fetchedPageUrl = `/interviews/recruiter-candidate-count/fetchPage?${queryParams}&pageNumber=${currentPage || 1
        }&pageSize=${pageSize || 10}`

      const result = await axiosInstance.get(fetchedPageUrl)

      setColumns(result?.data?.columns)
      setTableData(result?.data?.data)
      setTotalPage(result?.data?.pagination?.pageCount)
      setRowCount(result?.data?.pagination?.rowCount)
      setCurrentPage(result?.data?.pagination?.page)
      setPageSize(result?.data?.pagination?.pageSize)
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id,
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const url = `/interviews/recruiter-candidate-count/fetchAll?${queryParams}&pageNumber=${currentPage || 1
        }&pageSize=${pageSize || 10}`
      const result = await axiosInstance.get(url)
      const response = result?.data?.data.map((e) => ({
        Recruiter: e.recruiter,
        Client: e.client,
        Role: e.role,
        Stage: e.stage,
        'Candidates count': e.candidate_count,
      }))
      CSVDownloader.downloadUnparsedCSV(
        response,
        'Recruiters_Candidate_Count_List.csv'
      )
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Recruiter',
        accessor: 'recruiter_name',
      },
      {
        Header: 'Applicant',
        accessor: 'applicant_name',
      },
      {
        Header: 'Client',
        accessor: 'client',
      },
      {
        Header: 'Role',
        accessor: 'role',
      },

      ...columns.map((col) => ({
        Header: col.Header,
        accessor: col.accessor,
      })),
      {
        Header: 'Date Created',
        accessor: 'created_at',
        Cell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : ''),
      },
    ],
    [columns]
  )

  return (
    <StyledRecruitersCandidateCountList>
      <Flex justify="space-between">
        <DashboardItemTitle title="Recruiters Candidate Count List" />
        <Flex gap="0.5rem">
          <ExportButton onClick={handleExport}>Export</ExportButton>
        </Flex>
      </Flex>

      {loading && <Loader />}

      {tableData?.length > 0 ? (
        <TableRolesDisplay
          height="100%"
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          data={tableData}
          columns={tableColumns}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          fetchData={fetchData}
          onClick={() => null}
          groupedByCol={'recruiter_name'}
        ></TableRolesDisplay>
      ) : (
        <NoData />
      )}
    </StyledRecruitersCandidateCountList>
  )
}

export default memo(RecruitersCandidateCount)

const StyledRecruitersCandidateCountList = styled.div`
  width: 100%;
  height: 100%;
`
const ExportButton = styled.button`
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: black;
  color: white;
  border-radius: 100px;
  word-spacing: 3px;
`
